import { render } from "./OrderAuth.vue?vue&type=template&id=385dc5b2&scoped=true"
import script from "./OrderAuth.vue?vue&type=script&lang=js"
export * from "./OrderAuth.vue?vue&type=script&lang=js"

import "./OrderAuth.vue?vue&type=style&index=0&id=385dc5b2&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao-up-up-mobile-spa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385dc5b2"]])

export default __exports__